module.exports = "img#logo {\n  cursor: pointer; }\n"